type EnvConfigMapStyles = {
    baseUrl: string;
    key: string;
    styleIds: EnvConfigOmTilesMapStyleIds;
};

type EnvConfigOmTilesMapStyleIds = {
    satellite: string;
    stylized: string;
    standard: string;
};

type EnvConfigAssets = {
    baseUrl: string;
};

type EnvConfigApi = {
    baseUrl: string;
    authToken: string;
    authApplicationId: string;
};

type EnvConfig = {
    mapStyles: EnvConfigMapStyles;
    assets: EnvConfigAssets;
    api: EnvConfigApi;
};

export const envConfig: EnvConfig = {
    mapStyles: {
        baseUrl: import.meta.env.CONFIG_MAP_STYLE_BASE_URL,
        key: import.meta.env.CONFIG_MAP_STYLE_ACCESS_KEY,
        styleIds: {
            satellite: import.meta.env.CONFIG_MAP_STYLE_ID_DEFAULT_SATELLITE,
            stylized: import.meta.env.CONFIG_MAP_STYLE_ID_DEFAULT_STYLIZED,
            standard: import.meta.env.CONFIG_MAP_STYLE_ID_DEFAULT_STANDARD,
        },
    },
    assets: {
        baseUrl: import.meta.env.CONFIG_ASSETS_BASE_URL,
    },
    api: {
        baseUrl: import.meta.env.CONFIG_API_BASE_URL,
        authToken: import.meta.env.CONFIG_API_HEADER_AUTH_TOKEN,
        authApplicationId: import.meta.env
            .CONFIG_API_HEADER_AUTH_APPLICATION_ID,
    },
};
